import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import { RiderDrawerData, RiderResponse } from './rider-request.type';
import { Observable } from 'rxjs';
import { RIDER_REQUEST_DRAWER_WRAPPER } from './rider-request.type';
import {
  OpenQuoteRequestsItem,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { BondsListItem } from '@sbd-account-portal/app/modules/bonds/bonds-list/bonds-list.type';
import { QuoteRequestsListItem } from '@sbd-account-portal/app/modules/quote/requests-list/quote-request.type';
import { CIPXDrawerManagerService } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-manager.service';
import {
  RiderRequestWrapperComponent,
} from '@sbd-account-portal/app/modules/rider-request/rider-request-wrapper/rider-request-wrapper.component';

@Injectable({
  providedIn: 'root',
})
export class CIPXRiderRequestService {
  private _httpClient = inject(HttpClient);
  item = signal<OpenQuoteRequestsItem | BondsListItem | QuoteRequestsListItem>(null);
  private _drawerManagerService = inject(CIPXDrawerManagerService);
  riderRequested = signal<Boolean>(false)


  constructor() {
  }

  createRequest(postData: any): Observable<RiderResponse> {
    return this._httpClient
      .post<RiderResponse>(
        `${environment.apiBaseUrl}/v4/rider/request`,
        postData,
      ).pipe(
        map((response) => {
          if(response?.success){
            this.riderRequested.set(true)
          }
          return response;
        }),
      );
  }


  /**
   * Opens the shopping rider request drawer if a drawer wrapper is provided
   */
  openDrawer() {
    this._drawerManagerService.openDrawer(RiderRequestWrapperComponent, {
      data: {
        title: 'Rider Request',
        qr: this.item(),
      },
    });
  }

  clear() {
    this.item.set(null);
    // Emit event for external components
    // this._cartCleared.next();
  }
}
